module.exports = __webpack_public_path__ + "dc298a5b27660f37f84bd8e2b128b049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-6.png
// module id = 310
// module chunks = 1